<template>
  <the-dialog-box
    ref="dialogBox"
    :submit="submit"
    :submit-btn-text="item.id ? 'Update' : 'Create'"
    :max-width="550"
  >
    <template slot="header">
      <span>{{ item.id ? 'Update' : 'Create' }} Panel</span>
    </template>
    <template slot="body">
      <div class="d-flex flex-column">
        <div class="d-flex flex-column">
          <span
            style="color: #000; font-size: 16px;"
            class="fw500 pb-1"
          >Name<RedAsterisk /></span>
          <v-text-field
            v-model="item.name"
            outlined
            dense
            placeholder="Enter Name"
            :rules="[(v) => !!v || 'Name is required']"
          />
        </div>

        <div class="d-flex flex-column">
          <span
            style="color: #000; font-size: 16px;"
            class="fw500 pb-1"
          >Description</span>
          <v-textarea
            v-model="item.description"
            outlined
            rows="3"
            placeholder="Enter Description"
          />
        </div>

        <div class="d-flex flex-column">
          <span
            style="color: #000; font-size: 16px;"
            class="fw500 pb-1"
          >Image Width</span>
          <v-file-input
            v-model="item.img_w"
            outlined
            dense
            accept="image/*"
            placeholder="Enter Image Width"
          />
        </div>

        <div class="d-flex flex-column">
          <span
            style="color: #000; font-size: 16px;"
            class="fw500 pb-1"
          >Image Height</span>
          <v-file-input
            v-model="item.img_h"
            outlined
            dense
            accept="image/*"
            placeholder="Enter Image Height"
          />
        </div>
      </div>
    </template>
  </the-dialog-box>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  components: {

  },
  props: {

  },
  data: () => ({
    item: null,
    itemDto: {
      id: 0,
      name: null,
      description: null,
      img_w: null,
      img_h: null,
    },
  }),
  computed: {
    ...mapState({

    }),
    ...mapGetters([

    ]),
  },
  watch: {

  },
  created() {
    this.item = { ...this.itemDto };
  },
  methods: {

    async get(id) {
      if (!id) return;
      const submitModel = {
        filters: {
          id,
        },
      };
      const res = await this.$api.panel.read(submitModel);
      if (!res || res.length < 1 || !res[0]) return;
      const firstIndex = 0;
      this.item = res[firstIndex];
    },

    async submit() {
      if (!this.item) return false;
      const formData = new FormData();
      if (this.item.id) formData.append('id', this.item.id);
      formData.append('name', this.item.name);
      if (this.item.description) formData.append('description', this.item.description);
      if (this.item.img_w) formData.append('img_w', this.item.img_w);
      if (this.item.img_h) formData.append('img_h', this.item.img_h);
      let res;
      if (this.item.id) {
        res = await this.$api.panel.store(formData, 'update');
      } else {
        res = await this.$api.panel.store(formData);
      }

      if (!res) {
        this.$bus.$emit('showError');
        return false;
      }

      this.$bus.$emit('showSuccess');
      this.$emit('success');
      return res;
    },

    open(id) {
      if (id) {
        this.item.id = id;
        this.get(id);
      } else {
        this.item = { ...this.itemDto };
      }
      this.$refs.dialogBox.open();
    },
  },
};
</script>
